import { render, staticRenderFns } from "./Write.vue?vue&type=template&id=422c3ee3&"
import script from "./Write.vue?vue&type=script&lang=js&"
export * from "./Write.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports